require('./stylist-services.scss')

module.exports = {
  template: require('./stylist-services.pug')()
  controller: require('./stylist-services.ctrl')
  bindings:
    stylist: '<',
    onSubmit: '&'
}
